import { render, staticRenderFns } from "./ItemFilterComponent.vue?vue&type=template&id=b4d5d15e&"
import script from "./ItemFilterComponent.vue?vue&type=script&lang=js&"
export * from "./ItemFilterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports